module.exports = __webpack_public_path__ + "static/media/contactsPink.a76686b1.svg";